import React from 'react';

export interface INavBarItemProps {
    image: string;
    link: string;
}

const ImageLink: React.FC<INavBarItemProps> = (props: INavBarItemProps) => {
    return (
        <a href={props.link}>
            <img src={props.image} alt="" />
        </a>
    );
  }
  
  export default ImageLink;